import { render, staticRenderFns } from "./StudentsNew.vue?vue&type=template&id=e8ef9a98&scoped=true&"
import script from "./StudentsNew.vue?vue&type=script&lang=js&"
export * from "./StudentsNew.vue?vue&type=script&lang=js&"
import style0 from "./StudentsNew.vue?vue&type=style&index=0&id=e8ef9a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ef9a98",
  null
  
)

export default component.exports